module.exports = __webpack_public_path__ + "img/guanghua-tab4.7da49021.png";